import type { CfcConditionCode, CfcEligibleCondition } from "./cfcConditions";

export type CfcOrderStep = "provider" | "review" | "select" | "attestAuthorize";

export interface CfcOrderRequest {
  source_req_identifier: string;
  lims_id: string;
  npi: string;
  collection_date?: string;
  selected_conditions: CfcConditionCode[];
  is_O28_5_aneuploidy: boolean;
  other_aneuploidy_icd_10_codes: string;
  is_mobile_phlebotomy: boolean;
}

export interface CfcPatientData {
  reqId: string;
  sfId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  aneuploidyReportId: string;
  cfcEligibleCollectByDate: string;
  eligibleConditions: CfcEligibleCondition[];
  isCfcEligibilityOverridden: boolean;
}

export interface CfcFormData {
  clinicAccountNumber: string;
  isMobilePhlebotomyAccount: boolean;
  orderingHealthcareProviders: string;
  orderingHealthcareNPI: string;
  collectionDate: string;
  selectedConditions: CfcConditionCode[];
  icd10Abnormal: boolean;
  icd10OtherCodes: string;
  isMobilePhlebotomy: boolean;
  attestation1: boolean;
  attestation2: boolean;
  attestation3: boolean;
  providerAuthorization: boolean;
}

export const initialCfcFormData: CfcFormData = {
  clinicAccountNumber: "",
  isMobilePhlebotomyAccount: false,
  orderingHealthcareProviders: "",
  orderingHealthcareNPI: "",
  collectionDate: "",
  selectedConditions: [],
  icd10Abnormal: false,
  icd10OtherCodes: "",
  isMobilePhlebotomy: false,
  attestation1: false,
  attestation2: false,
  attestation3: false,
  providerAuthorization: false,
};
